module.exports = {"version":1,"title":"Daily Plans","fields":[{"label":"Tasks","type":"text","data":"## Opener\n\n\n## Activities\n\n\n## Homework\n"}],"attachments":{"label":"Tasks","type":"text","data":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/dailyplantemplate.json
// module id = 3EEV
// module chunks = 1